import { CirclePlusIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Sits beside the Professional Summary header and opens the editor.
export const AddExecutiveSummaryButton = ({
  onClick,
}: {
  onClick: () => void;
}) => {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className="h-6 w-6"
            onClick={onClick}
            size="icon"
            type="button"
            variant="ghost"
          >
            <CirclePlusIcon
              className="h-4 w-4 text-slate-400"
              strokeWidth={1.5}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Add Executive Summary</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
